export default __webpack_public_path__ + "static/morePrints-68ab13463322413edeacc9b7d2a4801a.jpg";